import { Original, Polling } from 'components/common';
import { useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getOriginalById } from 'utils/legacyEbService';
import { findIndex } from 'lodash';

const useOriginalById = (contractAddress: string, id: string) => {
  const { status, data: original } = useQuery<Original, Error>(
    ['originals', contractAddress, id],
    () => getOriginalById(contractAddress, id),
    {
      refetchInterval: Polling.fast,
    }
  );

  // Update the full list of originals
  const queryClient = useQueryClient();
  useEffect(() => {
    queryClient.setQueryData('originals', (old: Original[] | undefined) => {
      if (!old) return [];
      if (!original) return old;

      const index = findIndex(old, o => o.id === id);

      const updated = [...old];
      updated[index] = original;
      return updated;
    });
  }, [original, queryClient, id]);

  return {
    original,
    print: original?.print,
    status,
  };
};

export default useOriginalById;
